import type { ReactNode } from "react";

import { cx } from "@/lib/cx";

import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  /** Decorative icon. */
  icon?: ReactNode;
  /** The next step, e.g. a Button. Every empty state says what to do (FR-PROJ-008). */
  action?: ReactNode;
  headingLevel?: 2 | 3 | 4;
  className?: string | undefined;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  headingLevel = 2,
  className,
}: EmptyStateProps) {
  const Heading = `h${String(headingLevel)}` as "h2" | "h3" | "h4";
  return (
    <div className={cx(styles.empty, className)}>
      {icon !== undefined && (
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
      )}
      <Heading className={styles.title}>{title}</Heading>
      {description !== undefined && <p className={styles.description}>{description}</p>}
      {action}
    </div>
  );
}
